import { authService } from './auth';
import { API_BASE, ApiError } from './core.api';

export interface ExportPropertyDossierRequest {
  includePropertySummary: boolean;
  includeTenants: boolean;
  includeDocuments: boolean;
  includeReminders: boolean;
}

export interface ExportTenantDossierRequest {
  includeContactDetails: boolean;
  includeRentalAgreements: boolean;
  includeDocuments: boolean;
  includeTimeline: boolean;
  includeRelatedReminders: boolean;
}

export interface DownloadedFile {
  blob: Blob;
  fileName: string;
}

async function requestFile(path: string, body: unknown): Promise<DownloadedFile> {
  const token = authService.accessToken;
  if (!token) {
    authService.logout();
    throw new Error('Not authenticated');
  }

  const response = await fetch(`${API_BASE}${path}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  if (response.status === 401) {
    authService.logout();
    throw new Error('Unauthorized');
  }

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Unknown error' }));
    throw new ApiError(error.error || `HTTP ${response.status}`, response.status, error.code, error.details);
  }

  const blob = await response.blob();
  const header = response.headers.get('Content-Disposition') || '';
  const match = /filename="([^"]+)"/i.exec(header);
  const fileName = match?.[1] || 'dossier.pdf';
  return { blob, fileName };
}

export const dossiersApi = {
  exportProperty: (propertyId: string, data: ExportPropertyDossierRequest) =>
    requestFile(`/properties/${propertyId}/dossier/export`, data),
  exportTenant: (tenantId: string, data: ExportTenantDossierRequest) =>
    requestFile(`/tenants/${tenantId}/dossier/export`, data),
};
